import { AssetfiAssetType } from '@/types/asset-type';

export default function DisconnectSvg({ width, height }: AssetfiAssetType) {
  return (
    <svg width={width} height={height} viewBox="0 0 17 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.5957 5.28144C2.06723 6.56551 1.0957 8.49108 1.0957 10.6436C1.0957 14.5095 4.22971 17.6436 8.0957 17.6436C11.9617 17.6436 15.0957 14.5095 15.0957 10.6436C15.0957 8.49108 14.1242 6.56551 12.5957 5.28144M8.0957 1.64355V8.64355"
        stroke="#242424"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
